document.addEventListener("DOMContentLoaded", () => {
    const MENU_COLLAPSIBLE = document.querySelectorAll('.menu__item-title--collapsible')
    if ( window.innerWidth >= 920) {
        // MENU_COLLAPSIBLE.forEach( item => {
        //     item.addEventListener('mouseover', () => {
        //         item.querySelector('.dropdown-icon').click();
        //     })

        //     item.addEventListener('mouseleave', () => {
        //         item.querySelector('.dropdown-icon').click();
        //     })
        // })
    }

    linkToScroll.forEach( item => {
        document.querySelectorAll(`.section-menu a[href="${item.href}"]`).forEach( href => {
            href.setAttribute('href',item.section);
        })

        document.querySelectorAll(`.section-menu a[href="${item.section}"]`).forEach( section => {

            section.addEventListener('click', function (e) {
                e.preventDefault();

                let href =  item.section; 
                let offsetTop = document.querySelector(href).offsetTop - document.querySelector('.section-menu .accordion__panel').offsetHeight;

                scroll({
                    top: offsetTop,
                    behavior: "smooth"
                });

                // in mobile
                if ( document.querySelector('.section-menu .accordion-toggle.is-open .accordion__summary') ) {
                    document.querySelector('.section-menu .accordion-toggle.is-open .accordion__summary').click();
                }
            });
        })
    })
})